import React from "react";
import { ItemList } from "schema-dts";
import { jsonLdScriptProps } from "react-schemaorg";
import { Item } from "@sitecore-jss/sitecore-jss-nextjs";
import { getSiteBaseUrl } from "../helpers/site-helper";

export const buildLocationGuidesJsonLd = (items: Item[]): JSX.Element => {
  if (!items?.length) {
    return <></>;
  }
  return (
    <script
      {...jsonLdScriptProps<ItemList>({
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: items.map((item, index) => ({
          "@type": "ListItem",
          position: index,
          url: `${getSiteBaseUrl('Editorial')}${item.url}`,
        })),
      })}
    />
  );
};
